module.exports = "/_next/static/images/b5ca56c5d9451dbd46a18c10f2da7211-woman-holding-card-smiling@0.5x.jpg.webp";